export const CTestimonialMastheadFragments = {
  field: `
    fragment testimonialMasthead on testimonialMasthead_MatrixField {
      ... on testimonialMasthead_block_Entry {
        id
        typeHandle
        idName
        color
        heading
        copy
        desktopImage {
          url @transform(mode: "crop", width: 2000, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        mobileImage {
          url @transform(mode: "crop", width: 640, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        backgroundVideo {
          url
          title
          embeddedAsset {
            url
            title
            providerName
          }
        }
      }
    }
  `,
}
